// Единые константы бренда (чтобы менять в одном месте)
export const APP_NAME = 'Packer';
export const APP_TAGLINE = 'Система управления производством';

// Путь к логотипу (лежит в public/)
export const APP_LOGO_SRC = '/assets/logo_packer.png';

